import i18next from 'i18next';

i18next.addResources('es_CL', 'DeliveryTypeButton', {
  validationDelivery:
    'Para poder seleccionar el modo de delivery de PedidosYA debes tener configurado Oneclick o Webpay como método de pago desde el Command Center.',
  activeDelivery: 'Delivery activo'
});

i18next.addResources('es_CR', 'DeliveryTypeButton', {
  validationDelivery:
    'Para poder seleccionar el modo de delivery de PedidosYA debes tener configurado Oneclick o Webpay como método de pago desde el Command Center.',
  activeDelivery: 'Delivery activo'
});
